export const SINGLE_WITH_SECTION_FOCUSED = '@single_with_section_focused';
export const SINGLE_WITH_PAGE_FOCUSED = '@single_with_page_focused';
export const SINGLE_WITH_TFM_SECTION_FOCUSED = '@single_with_tfm_section_focused';
export const SINGLE_WITH_TFM_PAGE_FOCUSED = '@single_with_tfm_page_focused';
export const MULTI_WITH_SECTION_FOCUSED = '@multi_with_section_focused';
export const MULTI_WITH_PAGE_FOCUSED = '@multi_with_page_focused';
export const MULTI_WITH_TFM_SECTION_FOCUSED = '@multi_with_tfm_section_focused';
export const MULTI_WITH_TFM_PAGE_FOCUSED = '@multi_with_tfm_page_focused';
